import GithubSlugger from "github-slugger";

export function createHeadingSlugger(): GithubSlugger {
	return new GithubSlugger();
}

export function slugifyHeading(slugger: GithubSlugger, title: string): string {
	return slugger.slug(title.trim());
}
